module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/2/5-2463a1ded5978293a0989cde5020ea07.jpg";